module.exports = __webpack_public_path__ + "img/menuTopLogo.65de82f4.png";